<template>
    <div v-if="openingHours" class="open-hours">
        <DSFontIcon :code="icon" size="xxxl" icon-style="line" />
        <p>
            <span class="block">
                <strong v-if="name">{{ name }}</strong>
                <span
                    v-for="openHours, key in openingHours"
                    :key="`open-hour-${key}`"
                    class="open-hour"
                >
                    <span>{{ openDatesRangeString(openHours) }}</span>
                    <span>{{ openHoursRangeString(openHours) }}</span>
                </span>
            </span>
        </p>
    </div>
</template>
<script setup>
defineProps({
    name: {
        type: String,
        required: false,
        default: null,
    },
    icon: {
        type: String,
        required: true,
    },
    openingHours: {
        type: Array,
        required: true,
    },
});

const openDatesRangeString = openHours => [...new Set([openHours.from, openHours.to ])].join(' - ');
const openHoursRangeString = openHours => openHours.hours.map(item => formatTimeStrings(item.startTime, item.endTime)).join(', ') || '-';
const formatTimeStrings = (start, end = null) => {
    if (end) {
        return `${formatTimeDisplay(start)} - ${formatTimeDisplay(end)}`;
    }

    return formatTimeDisplay(start);
};
const formatTimeDisplay = time => {
    if (typeof(time) === 'string') {
        return time.replace(/^0/, '').replace(/:00$/, '').replace(':', '.');
    }

    return '';
};
</script>
<script>
export default {
    name: 'OpeningHours',
};
</script>
<style scoped>
.open-hours p {
  margin-top: 0;
}
.open-hours .block {
  display: block;
}
.open-hours .block:not(:first-child) {
  margin-top: 1rem;
}
.open-hours .open-hour {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}
.open-hours .open-hour > :last-child {
  font-weight: 700;
}
</style>
